export { default as Storage } from './base';
export { default as ChromeStorage } from './chrome-storage';
export { default as CookieStorage } from './cookie-storage';
export { default as LocalStorage } from './local-storage';
